import apiClient, { getBenefitsDictionary } from "../../../../services/apiClient";

import address_dictionary from '../data/addresses.json'

import { createArrBuildAndCorpus } from '../helpers/address';

import { sendFileAsBinaryPOST } from '../../../../services/saveFile';



export async function postAnketa(data, files){
    //    cert: child.birthCertificate.files,
    //    ben: benefits.files,
    //    preferences: preferences.files

    const save_anketa = await apiClient.post('requests', data);

    if(!save_anketa.data) return;

    const { _id } = save_anketa.data;

    //const _id = "68caf8d063db2000352811d4";

    const res_save_files = [];

    for(const part in files){
        
        if(!files[part]) continue;

        for(const file of files[part]){
            res_save_files.push(await sendFileAsBinaryPOST({_id, file, typedoc: "request", part}))
        }
    }


    return res_save_files;
}


export async function updateAnketa(id, data) {

    try {
        const response = await apiClient.put(`requests/${id}/main_info`, data);
        return response.data;
    } catch (error) {
        console.error('Error updating application:', error);
        throw error;
    }
}


export async function deleteFile(requestId, fileId, section) {
    try {
        const response = await apiClient.delete(`requests/${requestId}/file/${fileId}/${section}`);
        return response.data;
    } catch (error) {
        console.error('Error deleting file:', error);
        throw error;
    }
}


export async function uploadFiles(requestId, files) {
    try {
        const res_save_files = [];

        for(const part in files){
            
            if(!files[part]) continue;

            for(const file of files[part]){
                res_save_files.push(await sendFileAsBinaryPOST({_id: requestId, file, typedoc: "request", part}))
            }
        }

        return res_save_files;
    } catch (error) {
        console.error('Error uploading files:', error);
        throw error;
    }
}

export async function findKgInfo(search){

    const prep_row = (row)=>{ const { _id, name, number, contacts } = row; return ({ _id, name: `${number} ${name}, ${contacts.address.string}`})};

    const url = `/find_kgs?find_by=name&find_by=number&returns_f=name&returns_f=number&returns_f=contacts.address.string&returns_f=contacts.address.district&search=${search}&limit=99`
    
    const data = await apiClient.get(url);

    const pr_data = data.data && data.data.map(r=>prep_row(r)) || [];
    
    return  pr_data;

};


export async function findKgsPaginated({ search = '', page = 0 }) {

    const KG_SEARCH_LIMIT = 10;

    const prep_kg_row = (row) => {
        const { _id, name, number, contacts } = row;
        return { _id, name: `${number} ${name}, ${contacts?.address?.string || ''}` };
    };

    const body = {
        search: search ? { number: search } : {},
        fields: ['number', 'name', 'contacts.address.string'],
        page,
        limit: KG_SEARCH_LIMIT,
        sortfield: 'number',
        sortdirect: 'asc'
    };

    const data = await apiClient.post('find_kgs_pag', body);

    if (!data?.data) return { items: [], hasMore: false };

    const { data: rows, all_count, position_start } = data.data;

    const items = (rows || []).map(prep_kg_row);
    const loaded = position_start + items.length;
    const hasMore = loaded < all_count;

    return { items, hasMore, all_count };
}


async function findAddress(body){

    const url = 'address_find';

    const data = await apiClient.post(url, body);

    return data.data && data.data.data || null;

}

export async function find_districts({search, id}){

    const body = ({ search, id, by: "districts"});

    //return address_dictionary.disctricts;

    const ret = await findAddress(body);

    return ret && ret.districtsByLocality.map(r=>({_id: r.id, name: r.name.fullName})) || null;

}

export async function find_streets({ search, id}){

    const body = ({ search, id, by: "streets"});

    //return address_dictionary.street;

    const ret = await findAddress(body);

    return ret && ret.streetsByDistrict.map(r=>({_id: r.id, name: [r.name.fullName, r.name.shortToponym].join(" ") })) || null;

}

export async function find_buildings({ search, id}){

    const body = ({ search, id, by: "building"});

    //return address_dictionary.realbuildings;

    const ret = await findAddress(body);


    const data = ret && ret.aosByStreet || null;

    return createArrBuildAndCorpus(data);

}

export async function check_ben_brothers(kindergartenId, birthCertificateNumber, firstName, birthDate){

    const url = 'check_children_kindergarten';

    const result = await apiClient.post(url,{
        kindergartenId, birthCertificateNumber, firstName, birthDate
    });

    return result;
}

export async function checkEmployee(kindergartenId, rnokpp, firstName){

    const url = 'employee_check_exists';

    const data = {kindergartenId, rnokpp, firstName};

    const result = await apiClient.post(url, data);

    return result;

}

export async function getBenefits(){

    return await getBenefitsDictionary();

}

export async function getKgInfo(kg_id){
    const url = 'kgs_info?kg_id=' + kg_id;

    const result = await apiClient.get(url);

    const translate = (data)=>{
        const out = {
            _id: data.garten_pdo_id,
            number: data.garten_number,
            name: data.garten_name,
            contacts:{
                address:{
                    string: data.address_auxiliary,
                    district:""
                }
            }
        };

        return out;
    }

    return(result.data && result.data.map(d=>translate(d)));


}

// Перелік садочків, у яких є хоча б одна група за міжнародною угодою
// (додаткове вивчення мови івриту). Використовується для підказки на Step3
// та для перевірки конфлікту з фіксованою пільгою на Step5.
export async function findKgsWithInternationalAgreement(){

    const url = 'kindergartens/list?international_agreement=true';

    const data = await apiClient.get(url);

    if(!data?.data) return [];

    const uniqMap = new Map();

    data.data.forEach(kg => {
        if(!kg._id) return;
        if(!uniqMap.has(kg._id)) uniqMap.set(kg._id, { _id: kg._id, name: `${kg.number} ${kg.name}` });
    });

    return Array.from(uniqMap.values());

}